import { render, staticRenderFns } from "./Insights.vue?vue&type=template&id=c24b78b4&scoped=true"
import script from "./Insights.vue?vue&type=script&lang=js"
export * from "./Insights.vue?vue&type=script&lang=js"
import style0 from "./Insights.vue?vue&type=style&index=0&id=c24b78b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24b78b4",
  null
  
)

export default component.exports